export default __webpack_public_path__ + "static/top_staff_img_002-9c07df416b6c90996a08d6f89fc0ff59.jpg";